module.exports = __webpack_public_path__ + "img/puberty-decal-15.5879189a.png";